var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.043 20.5742C13.6387 20.5742 14.0684 20.0859 14.3906 19.2656L20.8848 2.2832C21.0215 1.92188 21.0996 1.60938 21.0996 1.33594C21.0996 0.798828 20.7676 0.466797 20.2305 0.466797C19.957 0.466797 19.6445 0.544922 19.2832 0.681641L2.24219 7.20508C1.5 7.48828 0.992188 7.91797 0.992188 8.52344C0.992188 9.26562 1.53906 9.54883 2.39844 9.80273L9.63477 11.9219L11.7441 19.1094C12.0078 19.998 12.291 20.5742 13.043 20.5742ZM9.97656 10.7793L2.94531 8.66992C2.66211 8.5918 2.59375 8.52344 2.59375 8.42578C2.59375 8.32812 2.66211 8.25 2.88672 8.16211L17.4082 2.64453C18.0039 2.41992 18.5898 2.12695 19.1074 1.89258C18.6289 2.27344 17.9453 2.81055 17.5645 3.19141L9.97656 10.7793ZM13.1406 18.9824C13.0332 18.9824 12.9746 18.9043 12.8867 18.6309L10.7773 11.5898L18.375 4.00195C18.7461 3.63086 19.3027 2.9375 19.6836 2.43945C19.4492 2.9668 19.1562 3.55273 18.9219 4.1582L13.4043 18.6699C13.3164 18.9043 13.248 18.9824 13.1406 18.9824Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.a6718118.svg";
export { ForwardRef as ReactComponent };